export const PAYMENT_STEPS_IDS = {
  CHECK_USER: 'check_user',
  SELECT_BANK: 'select_bank',
  TRANSFER: 'transfer',
  SUCCESS: 'success',
  TRANSFER_FORM: 'transfer_form',
  TRANSFER_CANCELED: 'transfer_canceled',
  PAYMENT_SUCCESS: 'payment_success',
  PAYMENT_WARNING: 'payment_warning',
  TRANSFER_UPLOAD: 'transfer_upload',
  TRANSFER_SEARCH: 'transfer_search',
  IN_DISPUTE: 'in_dispute',
} as const;

export const SELECTED_BANK_STORAGE_KEY = 'selected_bank';
